export default __webpack_public_path__ + "static/media/eth.618f15d5.png";